import { render, staticRenderFns } from "./ViewRecommendation.vue?vue&type=template&id=7fa722eb"
import script from "./ViewRecommendation.vue?vue&type=script&lang=js"
export * from "./ViewRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ViewRecommendation.vue?vue&type=style&index=0&id=7fa722eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports